import React, { Component } from 'react';
import { connect } from 'react-redux';
import Row from '../../../../common/grid/Row.js';
import Col from '../../../../common/grid/Col.js';
import Button from '../../../../common/button/Button.js';
import Input from "../../../../common/input/Input.js";

// Actions
import { setErrors, clearErrors } from '../../../../actions/error.js';
import { createDonor } from "../../../../actions/donor.js";

import { validate } from "../../../../helpers/validate.js";

import './AddDonor.css';

class AddDonor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      address: '',
      phone: '',
      email: '',
      contact_person: '',
      description: ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleInputChange(text, name) {
    this.setState({ [name]: text });
  }

  validate() {
    const checkAgainst = [
      'name',
      'address',
      'phone',
      'email',
      'description',
      'contact_person',
      'contact_person_phone',
      'responsible_person',
      'responsible_person_phone',
    ];

    const errors = validate(this.state, checkAgainst);

    this.props.addErrors(errors)
    return Object.keys(errors).length === 0;
  }

  onSubmitClick(e) {
    e.preventDefault();

    if (this.validate()) {
      // reset state
      this.setState({
        name: '',
        address: '',
        phone: '',
        email: '',
        contact_person: '',
        contact_person_phone: '',
        responsible_person: '',
        responsible_person_phone: '',
        description: ''
      });

      this.props.emptyErrors();
      this.props.createDonor(this.state);
      alert('Donor has been created!');
    }
  }

  render() {
    return (
      <div className='add-donor'>
        <h2>Add Donor</h2>
        <Col _bottom-8>
          <Input
            ph='Name'
            name='name'
            value={this.state.name}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Description'
            name='description'
            value={this.state.description}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Address'
            name='address'
            value={this.state.address}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Phone'
            name='phone'
            value={this.state.phone}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Email'
            name='email'
            value={this.state.email}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Contact Person'
            name='contact_person'
            value={this.state.contact_person}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Contact Person Phone'
            name='contact_person_phone'
            value={this.state.contact_person_phone}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Responsoble Person'
            name='responsible_person'
            value={this.state.responsible_person}
            onChange={this.handleInputChange}
          />
          <Input
            ph='Responsoble Person Phone'
            name='responsible_person_phone'
            value={this.state.responsible_person_phone}
            onChange={this.handleInputChange}
          />
          <Row _space-between>
            <Button className="btn-green btn-square" onClick={this.onSubmitClick}>Save</Button>
          </Row>
        </Col>
      </div >
    );
  }
}

const mapDispatchToProps = {
  addErrors: (errors) => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  createDonor
}

export default connect(null, mapDispatchToProps)(AddDonor);


// WEBPACK FOOTER //
// ./src/components/main/donors/add/AddDonor.js